<script>
import Keycloak from 'keycloak-js'

const keycloakAuth = new Keycloak(`config/keycloak.json`)

export default {
  name: 'KeycloakLogin',
  methods: {
    login () {
      keycloakAuth.init({onLoad: 'login-required', 'checkLoginIframe': false})
        .success((authenticated) => {
          window.sessionStorage.setItem('isLogged', true)
          if (!authenticated) {
            window.location.reload()
          }
          this.$store.dispatch('authLogin', keycloakAuth)
        }).error(error => {
          console.log('failed to login', error)
        })
    },
    logout () {
      this.$store.dispatch('authLogout')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/KeycloakLogin.vue